'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchProductTypesIfNeeded = exports.failureProductTypes = exports.receiveProductTypes = exports.requestProductTypes = exports.invalidateProductTypes = exports.INVALIDATE_PRODUCT_TYPES = exports.FAILURE_PRODUCT_TYPES = exports.RECEIVE_PRODUCT_TYPES = exports.REQUEST_PRODUCT_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 客户等级相关Actions
                                                                                                                                                                                                                                                                   */


var _api = require('../api');

var REQUEST_PRODUCT_TYPES = exports.REQUEST_PRODUCT_TYPES = 'REQUEST_PRODUCT_TYPES';
var RECEIVE_PRODUCT_TYPES = exports.RECEIVE_PRODUCT_TYPES = 'RECEIVE_PRODUCT_TYPES';
var FAILURE_PRODUCT_TYPES = exports.FAILURE_PRODUCT_TYPES = 'FAILURE_PRODUCT_TYPES';
var INVALIDATE_PRODUCT_TYPES = exports.INVALIDATE_PRODUCT_TYPES = 'INVALIDATE_PRODUCT_TYPES';

var invalidateProductTypes = exports.invalidateProductTypes = function invalidateProductTypes() {
    return {
        type: INVALIDATE_PRODUCT_TYPES
    };
};

var requestProductTypes = exports.requestProductTypes = function requestProductTypes() {
    return {
        type: REQUEST_PRODUCT_TYPES
    };
};

var receiveProductTypes = exports.receiveProductTypes = function receiveProductTypes(response) {
    var productTypes = response.data.map(function (x) {
        return _extends({
            id: x.product_type_id
        }, x);
    });
    return {
        type: RECEIVE_PRODUCT_TYPES,
        productTypes: productTypes
    };
};
var failureProductTypes = exports.failureProductTypes = function failureProductTypes(error) {
    return {
        type: FAILURE_PRODUCT_TYPES,
        error: error
    };
};

var shouldFetchProductTypes = function shouldFetchProductTypes(state) {
    var productTypes = state.productType.productTypes;
    if (productTypes.items.length === 0) {
        return true;
    }
    if (productTypes.isFetching) {
        return false;
    }
    return true;
};

var fetchProductTypesIfNeeded = exports.fetchProductTypesIfNeeded = function fetchProductTypesIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchProductTypes(getState())) {
            return dispatch(function (dispatch) {
                dispatch(requestProductTypes());
                return (0, _api.fetchProductTypes)().then(function (response) {
                    dispatch(receiveProductTypes(response.data));
                }).catch(function (error) {

                    dispatch(failureProductTypes(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/product_type.js
// module id = 878
// module chunks = 0